import React from 'react';

function CookingPot(props: object) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      {...props}
    >
      <path
        d="M11.3125 1.875V5.625"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0625 1.875V5.625"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8125 1.875V5.625"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 9.375H25.375V21.5625C25.375 22.3084 25.0787 23.0238 24.5512 23.5512C24.0238 24.0787 23.3084 24.375 22.5625 24.375H7.5625C6.81658 24.375 6.10121 24.0787 5.57376 23.5512C5.04632 23.0238 4.75 22.3084 4.75 21.5625V9.375Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.125 11.25L25.375 14.0625"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 11.25L4.75 14.0625"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CookingPot;
